import React, { useEffect, useState } from "react";
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormHelperText,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import Button from "../../common/Button";

const GroupModal = ({ open, onClose, onSubmit, isEdit, group }) => {
  const [name, setName] = useState({
    name: "",
  });

  const [errors, setErrors] = useState({
    name: "",
  });

  useEffect(() => {
    if (isEdit && group) {
      setName(group.name || "");
    } else {
      setName("");
    }
    // Reset errors when opening the modal
    setErrors({
      name: "",
    });
  }, [isEdit, group, open]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setName(value);
    // Clear the error for this field when user types
    if (errors[name]) {
      setErrors({
        ...errors,
        [name]: "",
      });
    }
  };

  const validateForm = () => {
    let valid = true;
    const newErrors = { ...errors };

    if (!name.trim()) {
      newErrors.name = "Group name is required";
      valid = false;
    }

    setErrors(newErrors);
    return valid;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      onSubmit(name);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      PaperProps={{
        style: { width: "600px" },
      }}
    >
      <DialogTitle>
        <Typography variant="h6">
          {isEdit ? "Edit Group" : "Add New Group"}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <FormControl fullWidth error={!!errors.name}>
                <TextField
                  name="name"
                  label="Group Name"
                  value={name}
                  onChange={handleChange}
                  variant="outlined"
                  fullWidth
                  error={!!errors.name}
                />
                {errors.name && (
                  <FormHelperText error>{errors.name}</FormHelperText>
                )}
              </FormControl>
            </Grid>
          </Grid>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} text="Cancel" backgroundColor="white" />

        <Button onClick={handleSubmit} text={isEdit ? "Update" : "Add"} Group />
      </DialogActions>
    </Dialog>
  );
};

export default GroupModal;
